export default {
  title: 'Indications for payment.',
  paymentType: 'Payment type',
  iban: 'IBAN',
  beneficiaryName: `Beneficiary's name`,
  beneficiaryAddress: `Beneficiary's address`,
  expirationDate: 'Expiration date',
  multipleDates: 'Enter several dates',
  expiration: 'Expiration',
  paymentDate: 'Payment date',
  amount: 'Amount',
  addExpirationDate: 'Add a new expiration date',
  select: 'Select the payment method',
  expirationDates: {
    title: 'Expiration date',
    date: 'Date',
    amount: 'Amount'
  },
  paymentTypes: {
    receipt: 'Domiciled receipt',
    transfer: 'Transference',
    issuedEffect: 'Effect due',
    effect: 'Effect',
    promissoryNote: 'Promissory note',
    check: 'Check',
    payment: 'Resident payment',
    cash: 'Cash',
    others: 'Others'
  }
}
